module.exports = __webpack_public_path__ + "img/oliver-borner7.5a742e21.jpg";